module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel04_770_280_en-a89179e5aa91988aca971a7f70db7efb.jpg";